import { useLocation } from 'react-router-dom'

import { CentralCardLayoutWrapper } from '@percent/cause-dashboard/common/components'
import { EmailVerificationDetail } from '../emailVerification/EmailVerificationDetail'
import { SIGN_UP_EMAIL_STORAGE_KEY } from './signUpEmailStorage'

export const SignUpCheckEmail = () => {
  const { state } = useLocation()
  // sessionStorage keeps the address across a refresh, which drops router state
  const email = (state as { email?: string } | null)?.email ?? sessionStorage.getItem(SIGN_UP_EMAIL_STORAGE_KEY)

  return (
    <CentralCardLayoutWrapper>
      <EmailVerificationDetail email={email ?? undefined} />
    </CentralCardLayoutWrapper>
  )
}
